import { api } from "./customers";

export interface UserManagement {
  full_name: string;
  email: string;
  active_status: number;
  role_id: number;
  profile_image: string;
  id: number;
}
export interface DashboardCustomersResponse {
    status: string;
    message: string;
    total_count: number;
    total_pages: number;
    current_page: number;
    data: UserManagement[];
    per_page: number;
    prev_page: number;
    nextPage: number;
  id: number;
  }
type DasboardCustomersResponse = DashboardCustomersResponse[];

type UserManagementsResponse = UserManagement[];  

export const UserManagementApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUserManagements: build.query<DasboardCustomersResponse, any>({
      query: (pagi) => `user?page=${pagi?.pageNo}&filter=${pagi?.name}`,
      providesTags: (result) =>
        result
          ? [
            ...result?.["data"]?.map(({ id }) => ({
                type: "UserManagement" as const,
                id,
              })),
              { type: "UserManagement", id: "LIST" },
            ]
          : [{ type: "UserManagement", id: "LIST" }],
    }),
    addUserManagement: build.mutation<UserManagement, Partial<UserManagement>>({
      query: (body) => ({
        url: `user`,
        method: "POST",
        body,
      }),
      transformResponse: (response: { data: UserManagement }, meta, arg) =>
        response.data,
      invalidatesTags: [{ type: "UserManagement", id: "LIST" }],
    }),
    getUserManagement: build.query<UserManagement, string>({
      query: (id) => `user/${id}`,
      transformResponse: (response: { data: UserManagement }, meta, arg) =>
        response.data,
    }),
    updateUserManagement: build.mutation<
      void,
      Pick<UserManagement, "id"> & Partial<UserManagement>
    >({
      query: ({ id, ...patch }) => ({
        url: `user/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: [{ type: "UserManagement", id: "LIST" }],
    }),
    deleteUserManagement: build.mutation<
      { success: boolean; id: number },
      number
    >({
      query(id) {
        return {
          url: `user/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: [{ type: "UserManagement", id: "LIST" }],
    }),
  }),
});

export const {
  useGetUserManagementQuery,
  useGetUserManagementsQuery,
  useAddUserManagementMutation,
  useUpdateUserManagementMutation,
  useDeleteUserManagementMutation,
} = UserManagementApi;
